(function () {
  'use strict';

  var SOURCE  = 'collection_les_iconiques';
  var VERSION = 'v5';

  function track(action, extra) {
    if (!window.dataLayer) return;
    window.dataLayer.push(Object.assign({
      event:      'ei_' + action,
      ei_source:  SOURCE,
      ei_version: VERSION
    }, extra || {}));
  }

  /* ── Filtres ────────────────────────────────────────────── */
  function initFilters() {
    var chips     = document.querySelectorAll('.ei-iconiques-chip');
    var cards     = document.querySelectorAll('.ei-iconiques-card');
    var noResults = document.querySelector('.ei-iconiques-no-results');
    if (!chips.length) return;

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var filter = chip.dataset.filter;
        chips.forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');

        var visible = 0;
        cards.forEach(function (card) {
          if (filter === 'all') {
            card.removeAttribute('data-hidden');
            visible++;
          } else {
            var tags = (card.dataset.tags || '').split(',').map(function (t) { return t.trim(); });
            if (tags.indexOf(filter) > -1) {
              card.removeAttribute('data-hidden');
              visible++;
            } else {
              card.setAttribute('data-hidden', 'true');
            }
          }
        });

        if (noResults) noResults.classList.toggle('is-visible', visible === 0);
        track('filter_apply', { ei_filter: filter });
      });
    });
  }

  /* ── FAQ accordion ──────────────────────────────────────── */
  function initFAQ() {
    var items = document.querySelectorAll('.ei-iconiques-faq-item');
    items.forEach(function (item) {
      var btn = item.querySelector('.ei-iconiques-faq-btn');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        items.forEach(function (i) { i.classList.remove('is-open'); });
        if (!wasOpen) {
          item.classList.add('is-open');
          var q = btn.querySelector('.ei-iconiques-faq-q');
          track('faq_open', { ei_question: q ? q.textContent.trim() : '' });
        }
      });
    });
  }

  /* ── Vidéo autoplay on scroll ───────────────────────────── */
  function initVideo() {
    var video = document.querySelector('.ei-iconiques-video-wrap video');
    if (!video || !('IntersectionObserver' in window)) return;

    var played = false, completed = false;

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          video.play().catch(function () {});
          if (!played) { played = true; track('video_play'); }
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.5 }).observe(video);

    video.addEventListener('ended', function () {
      if (!completed) { completed = true; track('video_complete'); }
    });
  }

  /* ── Product cards — view + quick add ───────────────────── */
  function initCards() {
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !entry.target.dataset.viewed) {
            entry.target.dataset.viewed = '1';
            track('view_product_card', { ei_product: entry.target.dataset.handle || '' });
          }
        });
      }, { threshold: 0.5 });
      document.querySelectorAll('.ei-iconiques-card').forEach(function (c) { obs.observe(c); });
    }

    document.querySelectorAll('.ei-iconiques-card-quick-add').forEach(function (btn) {
      /* Sprint mobile 2026-05-07 : empêcher tout autre handler (legacy ajaxCart sur la classe
         enj-add-to-cart-btn) de déclencher le redirect /cart. On capture en phase capture
         et on stop la propagation pour être SEUL handler du click. */
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var variantId = btn.dataset.variantId;
        if (!variantId) return;
        var card = btn.closest('.ei-iconiques-card');
        track('quick_add', { ei_product: card ? card.dataset.handle : '' });

        fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ id: variantId, quantity: 1 })
        }).then(function () {
          document.dispatchEvent(new CustomEvent('ei:cart:updated'));
          /* Sprint 2026-05-07 (Margot decision) : popup à l'ajout = LE PANIER complet
             (mode extended). Pas de mini-confirmation séparée, pas de page /cart. */
          if (window.eiCartPopover && typeof window.eiCartPopover.open === 'function') {
            window.eiCartPopover.open('extended');
          }
        });
      }, true); /* phase capture pour passer AVANT les autres handlers */
    });
  }

  /* ── Bundle — copier le code promo ─────────────────────── */
  function initBundle() {
    var btn = document.querySelector('.ei-iconiques-bundle-code');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var code = btn.dataset.code || 'BUONO10';
      if (navigator.clipboard) {
        navigator.clipboard.writeText(code).then(function () {
          var orig = btn.innerHTML;
          btn.textContent = 'Code copié !';
          setTimeout(function () { btn.innerHTML = orig; }, 2000);
        });
      }
      track('bundle_cta', { ei_code: code });
    });
  }

  /* ── Gazette newsletter (mode agnostique) ───────────────── */
  function initGazette() {
    var form = document.querySelector('.ei-iconiques-gazette-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var emailInput = form.querySelector('.ei-iconiques-gazette-input');
      var email = emailInput ? emailInput.value.trim() : '';
      if (!email || !email.includes('@')) return;

      var submitBtn = form.querySelector('.ei-iconiques-gazette-btn');
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = '…'; }

      var provider = form.dataset.provider || 'pending';
      track('newsletter_signup', { ei_provider: provider });

      // Inscription via Shopify customer endpoint (stack email natif Shopify Email)
      fetch('/contact', {
        method:  'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body:    'form_type=customer&utf8=✓&contact[email]=' + encodeURIComponent(email) + '&contact[tags]=gazette_iconiques_pending'
      }).finally(function () { showGazetteSuccess(form); });
    });
  }

  function showGazetteSuccess(form) {
    form.style.display = 'none';
    var s = form.closest('.ei-iconiques-gazette');
    var success = s ? s.querySelector('.ei-iconiques-gazette-success') : null;
    if (success) success.style.display = 'block';
  }

  /* ── GA4 — liens divers ─────────────────────────────────── */
  function initTracking() {
    document.querySelectorAll('.ei-iconiques-nav-item').forEach(function (el) {
      el.addEventListener('click', function () {
        track('nav_collection_click', { ei_collection: el.dataset.collection || '' });
      });
    });
    document.querySelectorAll('.ei-iconiques-blog-card').forEach(function (el) {
      el.addEventListener('click', function () { track('blog_article_click', { ei_url: el.href || '' }); });
    });
    document.querySelectorAll('.ei-iconiques-ugc-reel').forEach(function (el) {
      el.addEventListener('click', function () { track('ugc_click', { ei_pseudo: el.dataset.pseudo || '' }); });
    });
    document.querySelectorAll('.ei-iconiques-instagram-post').forEach(function (el) {
      el.addEventListener('click', function () { track('instagram_click', { ei_url: el.href || '' }); });
    });
    var tresorCta = document.querySelector('.ei-iconiques-tresors-cta');
    if (tresorCta) tresorCta.addEventListener('click', function () { track('tresor_click'); });
    var phone = document.querySelector('.ei-iconiques-service-btn--phone');
    if (phone) phone.addEventListener('click', function () { track('phone_call'); });
    var contact = document.querySelector('.ei-iconiques-service-btn--contact');
    if (contact) contact.addEventListener('click', function () { track('contact_click'); });
    document.querySelectorAll('.ei-iconiques-reassurance-item').forEach(function (el) {
      el.addEventListener('click', function () {
        var lbl = el.querySelector('.ei-iconiques-reassurance-label');
        track('reassurance_click', { ei_label: lbl ? lbl.textContent.trim() : '' });
      });
    });
  }

  /* ── Init ───────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initFilters();
    initFAQ();
    initVideo();
    initCards();
    initBundle();
    initGazette();
    initTracking();
  });

})();
